import { Box, Modal } from '@mui/material';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

import BaseInputValidation from '@/components/ui/Input/BaseInputValidation';
import ButtonCloseModal from '@/components/ui/Button/ButtonCloseModal';
import BaseSelect from '@/components/ui/Select/BaseSelect';

import usePatch from '@/hooks/usePatch';

import ModalStyle from '@/constants/ModalStyle';

const schemaG = yup.object().shape({
	name: yup.string().required(),
});

const schemaC = yup.object().shape({
	name: yup.string().required(),
	group: yup.string().required(),
});

export default function GroupAndCategory(props) {
	const { open, onClose, data, groups, type, refetch } = props;

	const isCategory = data?.id;

	const {
		handleSubmit,
		control,
		reset,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(isCategory ? schemaC : schemaG),
		defaultValues: {
			name: '',
			group: data?.id || '',
		},
	});

	const handleClose = () => {
		reset();
		onClose();
	};

	const { mutate: categoryAction } = usePatch({
		url: isCategory ? `categorycomponent` : `groupcategory`,
		method: 'post',
		callback: async (res) => {
			if ([200, 201].includes(res.status) && res.data) {
				toast.success(
					res.data?.message || `${isCategory ? 'Kategori' : 'Group'} ${res.status === 200 ? 'updated' : 'created'} successfully`
				);
			}
			props.onSave();
			reset();
			refetch(type);
		},
		onError: () => {
			handleClose();
		},
	});

	const onSubmit = (data) => {
		const { name, group } = data;
		const obj = { status: 1 };
		if (isCategory) {
			obj.categorytype = 'P-GRUPPE';
			obj.categorynumber = '';
			obj.categoryname = name;
			obj.group = group;
		} else {
			obj.groupname = name;
			obj.grouptype = 'P-group';
			obj.groupnumber = '';
		}
		categoryAction(obj);
	};
	return (
		<Modal open={open} onClose={handleClose} aria-labelledby='modal-category-group' aria-describedby='modal-notes' className='w-full'>
			<Box sx={{ ...ModalStyle, top: '25%' }} className='flex flex-col gap-4 w-[90%] md:w-[380px]'>
				<span className='text-2xl modal-title'>Legg til ny {isCategory ? 'Kategori' : 'Group'}</span>
				<ButtonCloseModal onClose={handleClose} />

				<hr />

				<form onSubmit={handleSubmit(onSubmit)} className='flex flex-col w-full gap-4'>
					{type !== 'group' && (
						<BaseSelect
							control={control}
							name='group'
							label='Kategori'
							errors
							data={groups}
							config={{
								styles: {},
								classes: 'col-span-3',
								disabled: false,
								optionLabel: '--category type--',
								keyVal: 'id',
								keyName: 'groupname',
								keyLabel: 'groupname',
							}}
							size='small'
						/>
					)}
					<BaseInputValidation control={control} name='name' label='Name' errors={errors} required />
					<hr />

					<div className='flex gap-4 ml-auto'>
						<button className='px-3 py-2 text-white rounded-md btn bg-primary' type='submit'>
							Legg til
						</button>
					</div>
				</form>
			</Box>
		</Modal>
	);
}
